import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { DeleteEventTypeDocument } from './delete.generated';

export const useDeleteEventType = (options: ApiOptions<typeof DeleteEventTypeDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(DeleteEventTypeDocument, {
    ...useNotifications(DeleteEventTypeDocument, {
      failure: t('api.common.error_generic'),
      success: t('api.event_types.delete_success'),
    }),

    update(cache, { data }) {
      if (data?.deleteEventType?.eventType == null) return;
      cache.evict({ id: cache.identify(data.deleteEventType.eventType) });
    },

    ...options,
  });
};
